import { render, staticRenderFns } from "./TableViewTable.vue?vue&type=template&id=cb793fd8&"
import script from "./TableViewTable.vue?vue&type=script&lang=ts&"
export * from "./TableViewTable.vue?vue&type=script&lang=ts&"
import style0 from "./TableViewTable.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports